// extracted by mini-css-extract-plugin
export var bottomRightDock = "_2o-0";